import { SvgIcon } from "@mui/material";
import React from "react";

function Messenger(props) {
  return (
    <SvgIcon viewBox="0 0 11 15" {...props}>
      <path
        d="M0 2.43754C0 1.98998 0.189644 1.56075 0.527213 1.24427C0.864781 0.927794 1.32262 0.75 1.80002 0.75L9.00008 0.75C9.47748 0.75 9.93532 0.927794 10.2729 1.24427C10.6105 1.56075 10.8001 1.98998 10.8001 2.43754V13.8285C10.8001 13.9048 10.7779 13.9796 10.7361 14.0451C10.6943 14.1106 10.6343 14.1642 10.5625 14.2002C10.4907 14.2362 10.4099 14.2533 10.3286 14.2496C10.2473 14.246 10.1686 14.2217 10.1008 14.1795L5.40005 11.8042L0.699306 14.1795C0.631541 14.2217 0.552812 14.246 0.471507 14.2496C0.390201 14.2533 0.309363 14.2362 0.237602 14.2002C0.165841 14.1642 0.105845 14.1106 0.0640032 14.0451C0.0221618 13.9796 4.20488e-05 13.9048 0 13.8285V2.43754ZM1.80002 1.59377C1.56132 1.59377 1.3324 1.68267 1.16361 1.84091C0.99483 1.99914 0.900008 2.21376 0.900008 2.43754V13.0404L5.15075 10.9461C5.2246 10.9001 5.31134 10.8755 5.40005 10.8755C5.48876 10.8755 5.5755 10.9001 5.64935 10.9461L9.90009 13.0404V2.43754C9.90009 2.21376 9.80527 1.99914 9.63648 1.84091C9.4677 1.68267 9.23878 1.59377 9.00008 1.59377H1.80002Z"
        fill="#5F5C5C"
      />
    </SvgIcon>
  );
}

export default Messenger;
